var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositsIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4.775a1.001 1.001 0 00-1.316-.949L9.162 6H17V4.775zM19 6V4.775a3 3 0 00-3.949-2.846l-11 3.666A3 3 0 002 8.442V17c0 1.656 1.341 3 2.999 3H5.5a1 1 0 100-2h-.501A.998.998 0 014 17V9a1 1 0 011-1h14a1 1 0 011 1v8c0 .553-.447 1-.999 1H18.5a1 1 0 000 2h.501A3 3 0 0022 17V9a3 3 0 00-3-3zm-7 9a1 1 0 011 1v2h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H9a1 1 0 110-2h2v-2a1 1 0 011-1z",
    fill: "#F9B035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositsIconYellow);
export default __webpack_public_path__ + "static/media/deposits-icon-yellow.c1a69f799cb0598b28c80c4495d28b10.svg";
export { ForwardRef as ReactComponent };